/* eslint-disable no-confusing-arrow */
import { Reducer } from 'redux';

// Constants
import CONST_ATTENDANCE from 'constants/attendance';

import { AttendanceState, AttendanceTypes } from './types';

const INITIAL_STATE: AttendanceState = {
  messageData: {
    Room: '',
    username: '',
    conversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
    typingStatus: false,
    tags: [],
    messages: [],
    attendantOwnerID: '',
    userPicture: '',
  },
  openedUsers: [],
  closedUsers: [],
  chatbotUsers: [],
  filteredUsers: [],
  filteredTags: [],
  hasMoreOpenedUsers: true,
  hasMoreClosedUsers: true,
  userMessage: {
    Room: '',
    messageData: {
      id: 0,
      message: '',
      username: '',
      type: '',
      tags: [],
      date: '',
      messageType: '',
    },
  },
  Qualification: {},
  Room: '',
  selectedConversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
  subscribe: false,
  AttendantConversationList: CONST_ATTENDANCE.USER_TYPES.GERAL,
  Tags: [],
  Tag: {
    ID: '',
    tag: '',
    userRegister: [],
    messageRegister: [],
  },
  Replies: [],
  Reply: {
    ID: '',
    title: '',
    description: '',
  },
  OfficeHours: [],
  OfficeHour: {
    ID: '',
    period: [],
    time: [],
    message: '',
    createdAt: 0,
    updatedAt: 0,
  },
  Attendants: [],
  Attendant: {
    ID: '',
    name: '',
    email: '',
    modules: [],
  },
  CurrentAttendant: {
    ID: '',
    name: '',
    email: '',
    modules: [],
  },
  totalCount: 0,
  loading: false,
  error: false,
  statusCode: 200,
  paginationError: false,
  Token: '',
  webhookList: [],
  webhookData: {
    ID: '',
    url: '',
    type: '',
  },
  heatmapData: {
    start: 0,
    end: 0,
    data: '',
    // [
    //   {
    //     firstReplyTimes: [
    //       {
    //         startedConversationAt: 0,
    //         attendantOwnerID: '',
    //         time: 0,
    //       },
    //     ],
    //     createdAt: 0,
    //   },
    // ],
  },
  wordCountData: [],
  ConversationReplyChartData: {
    users: [],
    totalWithAnswer: 0,
    totalWithNoAnswer: 0,
    report: [
      ['', ''],
      ['', 0],
    ],
  },
  humanAndChatbotChartData: {
    chatbotMessages: 0,
    humanMessages: 0,
  },
  TagsLinesChartData: [],
  RatingChartData: [
    ['', ''],
    ['', 0],
  ],
  CloseConversationChartData: {
    timeMean: 0,
    attendances: [
      ['', ''],
      ['', 0],
    ],
  },
  FirstReplyChartData: {
    timeMean: 0,
    attendances: [
      ['', ''],
      ['', 0],
    ],
  },
  FirstReplyScatterChartData: [],
  searchMessageId: -1,
  attendanceHistory: [],
  ratingList: {
    count: 0,
    ratingList: [],
  },
  attendantAssignmentEvent: {
    room: '',
    attendantId: '',
    attendantUsername: '',
    previousAttendantId: '',
    previousAttendantUsername: '',
    isNewAttendant: false,
  },
  numberOfMessagesList: [],
};

const reducer: Reducer<AttendanceState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Get Messages
    case AttendanceTypes.GET_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: action.payload.MessageData,
      };
    case AttendanceTypes.GET_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        messageData: INITIAL_STATE.messageData,
      };

    // List Opened users
    case AttendanceTypes.LIST_OPENED_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paginationError: false,
      };
    case AttendanceTypes.LIST_OPENED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paginationError: false,
        openedUsers: action.payload.firstRequest
          ? action.payload.Users
          : [...state.openedUsers, ...action.payload.Users],
      };

    case AttendanceTypes.LIST_OPENED_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paginationError: true,
      };

    // List Closed users
    case AttendanceTypes.LIST_CLOSED_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paginationError: false,
      };
    case AttendanceTypes.LIST_CLOSED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paginationError: false,
        closedUsers: action.payload.firstRequest
          ? action.payload.Users
          : [...state.closedUsers, ...action.payload.Users],
      };
    case AttendanceTypes.LIST_CLOSED_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paginationError: true,
      };

    // List Chatbot users
    case AttendanceTypes.LIST_CHATBOT_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        paginationError: false,
      };
    case AttendanceTypes.LIST_CHATBOT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paginationError: false,
        chatbotUsers: action.payload.firstRequest
          ? action.payload.Users
          : [...state.chatbotUsers, ...action.payload.Users],
      };
    case AttendanceTypes.LIST_CHATBOT_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        paginationError: true,
      };

    // Filter users by name
    case AttendanceTypes.FILTER_USERS_BY_NAME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.FILTER_USERS_BY_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filteredUsers: action.payload.Users,
      };

    case AttendanceTypes.FILTER_USERS_BY_NAME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Filter users by message
    case AttendanceTypes.FILTER_USERS_BY_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.FILTER_USERS_BY_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filteredUsers: action.payload.Users,
      };

    case AttendanceTypes.FILTER_USERS_BY_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Filter users by tag
    case AttendanceTypes.FILTER_USERS_BY_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.FILTER_USERS_BY_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filteredUsers: action.payload.Users,
      };

    case AttendanceTypes.FILTER_USERS_BY_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Filter users by name
    case AttendanceTypes.FILTER_TAG_BY_NAME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.FILTER_TAG_BY_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filteredTags: action.payload.tags,
      };

    case AttendanceTypes.FILTER_TAG_BY_NAME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Case has more users
    case AttendanceTypes.LOAD_HAS_MORE_OPENED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        hasMoreOpenedUsers: false,
      };

    // Case has more closed users
    case AttendanceTypes.LOAD_HAS_MORE_CLOSED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        hasMoreClosedUsers: false,
      };

    // CASES User Messages
    case AttendanceTypes.LOAD_NEW_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case AttendanceTypes.LOAD_NEW_MESSAGE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const userExists = state.openedUsers.find(
        (user) => user.Room === action.payload.message.Room,
      );

      if (userExists) {
        return {
          ...state,
          loading: false,
          error: false,
          openedUsers: state.openedUsers.map((user) =>
            user.Room === action.payload.message.Room
              ? {
                  ...user,
                  lastMessage: action.payload.message.messageData.message
                    ? action.payload.message.messageData
                    : user.lastMessage,
                  conversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
                  updatedAt: new Date().getTime(),
                  unreadMessages:
                    user.unreadMessages !== undefined &&
                    action.payload.message.messageData.type === 'user'
                      ? user.unreadMessages + 1
                      : 0,
                }
              : user,
          ),

          messageData:
            state.messageData.Room === action.payload.message.Room
              ? {
                  ...state.messageData,
                  messages: [
                    ...state.messageData.messages,
                    action.payload.message.messageData,
                  ],
                  conversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
                }
              : state.messageData,
        };
      }
      return {
        ...state,
        loading: false,
        error: false,
        chatbotUsers: state.chatbotUsers.filter(
          (user) => user.Room !== action.payload.message.Room,
        ),

        closedUsers: state.closedUsers.filter(
          (user) => user.Room !== action.payload.message.Room,
        ),

        openedUsers: [
          {
            Room: action.payload.message.Room,
            username: action.payload.message.messageData.username,
            conversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
            typingStatus: false,
            lastMessage: action.payload.message.messageData,
            attendantOwnerID: '',
            selectedUser: false,
            updatedAt: new Date(
              JSON.parse(action.payload.message.messageData.date),
            ).getTime(),
            unreadMessages: 1,
          },
          ...state.openedUsers,
        ],

        messageData:
          state.messageData.Room === action.payload.message.Room
            ? {
                ...state.messageData,
                messages: [
                  ...state.messageData.messages,
                  action.payload.message.messageData,
                ],
                conversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
              }
            : state.messageData,
      };

    case AttendanceTypes.LOAD_NEW_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Cases New User
    case AttendanceTypes.LOAD_NEW_USER_REQUEST:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case AttendanceTypes.LOAD_NEW_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        openedUsers: [action.payload.user, ...state.openedUsers],
      };
    case AttendanceTypes.LOAD_NEW_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASE Room
    case AttendanceTypes.LOAD_ROOM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Room: action.payload.Room,
        openedUsers: state.openedUsers.map((user) =>
          user.Room === action.payload.Room
            ? { ...user, selectedUser: true, unreadMessages: 0 }
            : { ...user, selectedUser: false },
        ),
      };

    // CASE conversation status
    case AttendanceTypes.LOAD_CONVERSATION_STATUS_SUCCESS:
      return {
        ...state,
        selectedConversationStatus: action.payload.status,
      };

    // CASE Subscribe
    case AttendanceTypes.LOAD_SUBSCRIBE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        subscribe: action.payload.status,
      };

    // Case Attendant Conversation List
    case AttendanceTypes.LOAD_ATTENDANT_CONVERSATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        AttendantConversationList: action.payload.AttendantID,
      };

    // Opened Dialogue Status
    case AttendanceTypes.SET_OPENED_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData:
          action.payload.user && action.payload.user.Room
            ? {
                ...state.messageData,
                conversationStatus: action.payload.status,
                messages: [
                  ...state.messageData.messages,
                  {
                    conversationStatus: action.payload.status,
                    messageType: 'conversationStatus',
                    date: JSON.stringify(new Date()),
                    id: 0,
                    message: '',
                    username: '',
                    type: 'attendant',
                    tags: [],
                  },
                ],
              }
            : state.messageData,

        openedUsers: [
          {
            ...action.payload.user,
            conversationStatus: action.payload.status,
            selectedUser: false,
          },
          ...state.openedUsers,
        ],
        closedUsers:
          action.payload.user && action.payload.user.Room
            ? state.closedUsers.filter(
                (user) => user.Room !== action.payload.user.Room,
              )
            : state.closedUsers,
        chatbotUsers:
          action.payload.user && action.payload.user.Room
            ? state.chatbotUsers.filter(
                (user) => user.Room !== action.payload.user.Room,
              )
            : state.chatbotUsers,
      };

    // Closed Dialogue Status
    case AttendanceTypes.SET_CLOSED_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData:
          action.payload.user && action.payload.user.Room
            ? {
                ...state.messageData,
                conversationStatus: action.payload.status,
                messages: [
                  ...state.messageData.messages,
                  {
                    Room: action.payload.user.Room,
                    conversationStatus: action.payload.status,
                    messageType: 'conversationStatus',
                    date: JSON.stringify(new Date()),
                    id: 0,
                    message: '',
                    username: '',
                    type: 'attendant',
                    tags: [],
                  },
                ],
              }
            : state.messageData,

        closedUsers: [
          {
            ...action.payload.user,
            conversationStatus: action.payload.status,
            selectedUser: false,
          },
          ...state.closedUsers,
        ],

        chatbotUsers: [...state.chatbotUsers],

        openedUsers:
          action.payload.user && action.payload.user.Room
            ? state.openedUsers.filter(
                (user) => user.Room !== action.payload.user.Room,
              )
            : state.openedUsers,
      };

    // CASES Update user
    case AttendanceTypes.UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: {
          ...state.messageData,
          attendantOwnerID: action.payload.attendantId,
          username: action.payload.username,
        },
        openedUsers: state.openedUsers.map((user) =>
          user.Room === action.payload.Room
            ? {
                ...user,
                attendantOwnerID: action.payload.attendantId,
                username: action.payload.username,
              }
            : user,
        ),
        closedUsers: state.closedUsers.map((user) =>
          user.Room === action.payload.Room
            ? {
                ...user,
                attendantOwnerID: action.payload.attendantId,
                username: action.payload.username,
              }
            : user,
        ),
        chatbotUsers: state.chatbotUsers.map((user) =>
          user.Room === action.payload.Room
            ? {
                ...user,
                attendantOwnerID: action.payload.attendantId,
                username: action.payload.username,
              }
            : user,
        ),
      };
    case AttendanceTypes.UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES Typing Status
    case AttendanceTypes.SET_TYPING_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.SET_TYPING_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        openedUsers: state.openedUsers.map((user) =>
          user.Room === action.payload.Room
            ? { ...user, typingStatus: action.payload.typingStatus }
            : user,
        ),
        closedUsers: state.closedUsers.map((user) =>
          user.Room === action.payload.Room
            ? { ...user, typingStatus: action.payload.typingStatus }
            : user,
        ),
        chatbotUsers: state.chatbotUsers.map((user) =>
          user.Room === action.payload.Room
            ? { ...user, typingStatus: action.payload.typingStatus }
            : user,
        ),
      };
    case AttendanceTypes.SET_TYPING_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES Tags

    // Get Tag
    case AttendanceTypes.GET_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        Tag: INITIAL_STATE.Tag,
      };
    case AttendanceTypes.GET_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tag: action.payload.Tag,
      };
    case AttendanceTypes.GET_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Tag: INITIAL_STATE.Tag,
      };

    // List Tags
    case AttendanceTypes.LIST_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        Tags: INITIAL_STATE.Tags,
      };
    case AttendanceTypes.LIST_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tags: action.payload.Tags,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.LIST_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Tags: INITIAL_STATE.Tags,
      };

    // Filter Tags
    case AttendanceTypes.FILTER_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        Tags: INITIAL_STATE.Tags,
      };
    case AttendanceTypes.FILTER_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tags: action.payload.Tags,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.FILTER_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Tags: INITIAL_STATE.Tags,
      };

    // Create Tag
    case AttendanceTypes.CREATE_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tags: [...state.Tags, action.payload.Tag],
      };
    case AttendanceTypes.CREATE_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Tags: INITIAL_STATE.Tags,
      };

    // Get Tag
    case AttendanceTypes.UPDATE_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.UPDATE_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tags: state.Tags.map((tag) =>
          tag.ID === action.payload.ID
            ? { ...tag, tag: action.payload.Tag }
            : tag,
        ),
      };
    case AttendanceTypes.UPDATE_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete Tag
    case AttendanceTypes.DELETE_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tags: state.Tags.filter((tag) => tag.ID !== action.payload.ID),
      };
    case AttendanceTypes.DELETE_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES User Tags
    case AttendanceTypes.GET_USER_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        Tags: INITIAL_STATE.Tags,
      };
    case AttendanceTypes.GET_USER_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Tags: action.payload.Tags,
      };
    case AttendanceTypes.GET_USER_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Tags: INITIAL_STATE.Tags,
      };

    // Create User Tag
    case AttendanceTypes.CREATE_USER_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_USER_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: {
          ...state.messageData,
          tags: [
            ...state.messageData.tags,
            { ID: action.payload.ID, tag: action.payload.Tag },
          ],
        },
      };
    case AttendanceTypes.CREATE_USER_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete User Tag
    case AttendanceTypes.DELETE_USER_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_USER_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: {
          ...state.messageData,
          tags: state.messageData.tags.filter(
            (tag) => tag.ID !== action.payload.ID,
          ),
        },
      };
    case AttendanceTypes.DELETE_USER_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES Message Tags

    // Create message tag
    case AttendanceTypes.CREATE_MESSAGE_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_MESSAGE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: {
          ...state.messageData,
          messages: state.messageData.messages.map((message) =>
            message.id === action.payload.messageID
              ? {
                  ...message,
                  tags: [
                    ...message.tags,
                    { ID: action.payload.ID, tag: action.payload.Tag },
                  ],
                }
              : message,
          ),
        },
      };
    case AttendanceTypes.CREATE_MESSAGE_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete message tag
    case AttendanceTypes.DELETE_MESSAGE_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_MESSAGE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: {
          ...state.messageData,
          messages: state.messageData.messages.map((message) =>
            message.id === action.payload.messageID
              ? {
                  ...message,
                  tags: message.tags.filter(
                    (tag) => tag.ID !== action.payload.ID,
                  ),
                }
              : message,
          ),
        },
      };
    case AttendanceTypes.DELETE_MESSAGE_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES Qualification
    case AttendanceTypes.GET_QUALIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_QUALIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Qualification: action.payload.Data,
      };
    case AttendanceTypes.GET_QUALIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Qualification: INITIAL_STATE.Qualification,
      };

    // Cases Replies

    // List Replies
    case AttendanceTypes.LIST_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.LIST_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Replies: action.payload.Replies,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.LIST_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Replies: INITIAL_STATE.Replies,
      };

    // Get Reply
    case AttendanceTypes.GET_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Reply: action.payload.Reply,
      };
    case AttendanceTypes.GET_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Reply: INITIAL_STATE.Reply,
      };

    // Filter Replies
    case AttendanceTypes.FILTER_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        Replies: INITIAL_STATE.Replies,
      };
    case AttendanceTypes.FILTER_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Replies: action.payload.Replies,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.FILTER_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Replies: INITIAL_STATE.Replies,
      };

    // Create Reply
    case AttendanceTypes.CREATE_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Replies: [action.payload.Reply, ...state.Replies],
      };
    case AttendanceTypes.CREATE_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Replies: INITIAL_STATE.Replies,
      };

    // Update Reply
    case AttendanceTypes.UPDATE_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.UPDATE_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Replies: state.Replies.map((reply) =>
          reply.ID === action.payload.Reply.ID ? action.payload.Reply : reply,
        ),
      };
    case AttendanceTypes.UPDATE_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete Reply
    case AttendanceTypes.DELETE_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Replies: state.Replies.filter(
          (reply) => reply.ID !== action.payload.ID,
        ),
      };
    case AttendanceTypes.DELETE_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Get Current User Picture
    case AttendanceTypes.GET_CURRENT_USER_PICTURE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_CURRENT_USER_PICTURE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData: { ...state.messageData, userPicture: action.payload.URL },
      };
    case AttendanceTypes.GET_CURRENT_USER_PICTURE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        messageData: { ...state.messageData, userPicture: '' },
      };

    // Get User Picture
    case AttendanceTypes.GET_USER_PICTURE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_USER_PICTURE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        openedUsers: state.openedUsers.map((user) =>
          user.Room === action.payload.Room
            ? { ...user, userPicture: action.payload.URL }
            : user,
        ),
      };
    case AttendanceTypes.GET_USER_PICTURE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Get attendant Picture
    case AttendanceTypes.GET_ATTENDANT_PICTURE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_ATTENDANT_PICTURE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendants: state.Attendants.map((attendant) =>
          attendant.email === action.payload.Room
            ? { ...attendant, attendantPicture: action.payload.URL }
            : attendant,
        ),
      };
    case AttendanceTypes.GET_ATTENDANT_PICTURE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Cases Office Hours

    // List Office Hours
    case AttendanceTypes.LIST_OFFICE_HOURS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.LIST_OFFICE_HOURS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        OfficeHours: action.payload.OfficeHours,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.LIST_OFFICE_HOURS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        OfficeHours: INITIAL_STATE.OfficeHours,
      };

    // Get Office Hours
    case AttendanceTypes.GET_OFFICE_HOURS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_OFFICE_HOURS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        OfficeHour: action.payload.OfficeHour,
      };
    case AttendanceTypes.GET_OFFICE_HOURS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        OfficeHour: INITIAL_STATE.OfficeHour,
      };

    // Create Office Hours
    case AttendanceTypes.CREATE_OFFICE_HOURS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_OFFICE_HOURS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        OfficeHours: [...state.OfficeHours, action.payload.OfficeHour],
      };
    case AttendanceTypes.CREATE_OFFICE_HOURS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Update
    case AttendanceTypes.UPDATE_OFFICE_HOURS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.UPDATE_OFFICE_HOURS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        OfficeHours: state.OfficeHours.map((hour) =>
          hour.ID === action.payload.OfficeHour.ID
            ? action.payload.OfficeHour
            : hour,
        ),
      };
    case AttendanceTypes.UPDATE_OFFICE_HOURS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete Office Hours
    case AttendanceTypes.DELETE_OFFICE_HOURS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_OFFICE_HOURS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        OfficeHours: state.OfficeHours.filter(
          (hour) => hour.ID !== action.payload.ID,
        ),
      };
    case AttendanceTypes.DELETE_OFFICE_HOURS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Cases Attendants

    // List Attendants
    case AttendanceTypes.LIST_ATTENDANTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.LIST_ATTENDANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendants: action.payload.Attendants,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.LIST_ATTENDANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Attendants: INITIAL_STATE.Attendants,
      };

    // Get Attendant
    case AttendanceTypes.GET_ATTENDANTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_ATTENDANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendant: action.payload.Attendant,
      };
    case AttendanceTypes.GET_ATTENDANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Attendant: INITIAL_STATE.Attendant,
      };

    // Filter Attendants
    case AttendanceTypes.FILTER_ATTENDANTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        Attendants: INITIAL_STATE.Attendants,
      };
    case AttendanceTypes.FILTER_ATTENDANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendants: action.payload.Attendants,
        totalCount: action.payload.totalCount,
      };
    case AttendanceTypes.FILTER_ATTENDANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Attendants: INITIAL_STATE.Attendants,
      };

    // Create Attendant
    case AttendanceTypes.CREATE_ATTENDANTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_ATTENDANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendants: [...state.Attendants, action.payload.Attendant],
      };
    case AttendanceTypes.CREATE_ATTENDANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Update Reply
    case AttendanceTypes.UPDATE_ATTENDANTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.UPDATE_ATTENDANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendants: state.Attendants.map((attendant) =>
          attendant.ID === action.payload.Attendant.ID
            ? action.payload.Attendant
            : attendant,
        ),
      };
    case AttendanceTypes.UPDATE_ATTENDANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete Attendants
    case AttendanceTypes.DELETE_ATTENDANTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_ATTENDANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Attendants: state.Attendants.filter(
          (attendant) => attendant.ID !== action.payload.ID,
        ),
      };
    case AttendanceTypes.DELETE_ATTENDANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Cases Current Attendant

    // Get Current Attendant
    case AttendanceTypes.GET_CURRENT_ATTENDANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_CURRENT_ATTENDANT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        CurrentAttendant: action.payload.Attendant,
      };
    case AttendanceTypes.GET_CURRENT_ATTENDANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        CurrentAttendant: INITIAL_STATE.CurrentAttendant,
      };

    // Get Token
    case AttendanceTypes.GET_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Token: action.payload.Token,
      };
    case AttendanceTypes.GET_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        Token: INITIAL_STATE.Token,
      };

    // Create Token
    case AttendanceTypes.CREATE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Token: action.payload.Token,
      };
    case AttendanceTypes.CREATE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete Token
    case AttendanceTypes.DELETE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        Token: '',
      };
    case AttendanceTypes.DELETE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // List Webhook
    case AttendanceTypes.LIST_WEBHOOK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.LIST_WEBHOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webhookList: action.payload.webhookList,
      };
    case AttendanceTypes.LIST_WEBHOOK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webhooksList: INITIAL_STATE.webhookList,
      };

    // Filter Webhook
    case AttendanceTypes.FILTER_WEBHOOK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        webhooksList: INITIAL_STATE.webhookList,
      };
    case AttendanceTypes.FILTER_WEBHOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webhookList: action.payload.webhookList,
      };
    case AttendanceTypes.FILTER_WEBHOOK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        webhooksList: INITIAL_STATE.webhookList,
      };

    // Create Webhook
    case AttendanceTypes.CREATE_WEBHOOK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.CREATE_WEBHOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webhooksList: [...state.webhookList, action.payload.webhookData],
      };
    case AttendanceTypes.CREATE_WEBHOOK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Update Webhook
    case AttendanceTypes.UPDATE_WEBHOOK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.UPDATE_WEBHOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webhookList: state.webhookList.map((webhook) =>
          webhook.ID === action.payload.webhookData.ID
            ? action.payload.webhookData
            : webhook,
        ),
      };
    case AttendanceTypes.UPDATE_WEBHOOK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Delete Webhook
    case AttendanceTypes.DELETE_WEBHOOK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.DELETE_WEBHOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        webhookList: state.webhookList.filter(
          (webhook) => webhook.ID !== action.payload.ID,
        ),
      };
    case AttendanceTypes.DELETE_WEBHOOK_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // Get HeatMap Report
    case AttendanceTypes.GET_HEATMAP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_HEATMAP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        heatmapData: action.payload.heatmapData,
      };
    case AttendanceTypes.GET_HEATMAP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        heatmapData: INITIAL_STATE.heatmapData,
      };

    // Get WordCount Report
    case AttendanceTypes.GET_WORDCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_WORDCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        wordCountData: action.payload.wordCountData,
      };
    case AttendanceTypes.GET_WORDCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        wordCountData: INITIAL_STATE.wordCountData,
      };

    // Get Line Report
    case AttendanceTypes.GET_TAGS_LINES_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_TAGS_LINES_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        TagsLinesChartData: action.payload.TagsLinesChartData,
      };
    case AttendanceTypes.GET_TAGS_LINES_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        TagsLinesChartData: INITIAL_STATE.TagsLinesChartData,
      };

    // Get Rating Report
    case AttendanceTypes.GET_RATING_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_RATING_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        RatingChartData: action.payload.RatingChartData,
      };
    case AttendanceTypes.GET_RATING_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        RatingChartData: INITIAL_STATE.RatingChartData,
      };

    // Get Close Converasation Report
    case AttendanceTypes.GET_CLOSE_CONVERSATION_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_CLOSE_CONVERSATION_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        CloseConversationChartData: action.payload.CloseConversationChartData,
      };
    case AttendanceTypes.GET_CLOSE_CONVERSATION_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        CloseConversationChartData: INITIAL_STATE.CloseConversationChartData,
      };

    // Get First Converasation Report
    case AttendanceTypes.GET_FIRST_REPLY_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_FIRST_REPLY_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        FirstReplyChartData: action.payload.FirstReplyChartData,
      };
    case AttendanceTypes.GET_FIRST_REPLY_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        FirstReplyChartData: INITIAL_STATE.FirstReplyChartData,
      };

    // Get Converasation Reply Report
    case AttendanceTypes.GET_CONVERSATION_REPLY_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_CONVERSATION_REPLY_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ConversationReplyChartData: action.payload.ConversationReplyChartData,
      };
    case AttendanceTypes.GET_CONVERSATION_REPLY_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        ConversationReplyChartData: INITIAL_STATE.ConversationReplyChartData,
      };

    // Get Human and Chatbot Report
    case AttendanceTypes.GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        humanAndChatbotChartData: INITIAL_STATE.humanAndChatbotChartData,
      };
    case AttendanceTypes.GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        humanAndChatbotChartData: action.payload.humanAndChatbotChartData,
      };
    case AttendanceTypes.GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        humanAndChatbotChartData: INITIAL_STATE.humanAndChatbotChartData,
      };

    // Get First Converasation Scatter Report
    case AttendanceTypes.GET_FIRST_REPLY_SCATTER_CHART_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case AttendanceTypes.GET_FIRST_REPLY_SCATTER_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        FirstReplyScatterChartData: action.payload.FirstReplyScatterChartData,
      };
    case AttendanceTypes.GET_FIRST_REPLY_SCATTER_CHART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        FirstReplyScatterChartData: INITIAL_STATE.FirstReplyScatterChartData,
      };

    // Visualized Message Status
    case AttendanceTypes.SET_VISUALIZED_MESSAGE_STATUS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { messageStatus } = action.payload;

      return {
        ...state,
        loading: false,
        error: false,
        messageData:
          state.messageData.Room === action.payload.Room
            ? {
                ...state.messageData,
                messages: state.messageData.messages.map((message) =>
                  message.type === CONST_ATTENDANCE.USER_TYPES.ATTENDANT &&
                  message.id >= messageStatus &&
                  message.messageStatus ===
                    CONST_ATTENDANCE.ATTENDANT_MESSAGE_STATUS.SENT
                    ? {
                        ...message,
                        messageStatus:
                          CONST_ATTENDANCE.ATTENDANT_MESSAGE_STATUS.VISUALIZED,
                      }
                    : message,
                ),
              }
            : state.messageData,
      };

    // Attendant Message Status
    case AttendanceTypes.SET_ATTENDANT_MESSAGE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        messageData:
          state.messageData.Room === action.payload.Room
            ? {
                ...state.messageData,
                messages: state.messageData.messages.map((message) => ({
                  ...message,
                  messageStatus: CONST_ATTENDANCE.ATTENDANT_MESSAGE_STATUS.SENT,
                })),
              }
            : state.messageData,
      };

    // Search Message Id
    case AttendanceTypes.LOAD_SEARCH_MESSAGE_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        searchMessageId: action.payload.messageId,
      };

    // Get Attendance History
    case AttendanceTypes.GET_ATTENDANCE_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case AttendanceTypes.GET_ATTENDANCE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        attendanceHistory: action.payload.attendanceHistory,
      };

    case AttendanceTypes.GET_ATTENDANCE_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        statusCode: action.payload.statusCode,
        attendanceHistory: INITIAL_STATE.attendanceHistory,
      };

    // Rating List
    case AttendanceTypes.LIST_RATING_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ratingList: state.ratingList,
      };
    case AttendanceTypes.LIST_RATING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ratingList: {
          count: action.payload.ratingList.count,
          ratingList: action.payload.ratingList.data,
        },
      };
    case AttendanceTypes.LIST_RATING_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        ratingList: INITIAL_STATE.ratingList,
      };

    // Number of Messages List
    case AttendanceTypes.LIST_NUMBER_OF_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        numberOfMessagesList: state.numberOfMessagesList,
      };
    case AttendanceTypes.LIST_NUMBER_OF_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        numberOfMessagesList: action.payload.numberOfMessagesList,
      };
    case AttendanceTypes.LIST_NUMBER_OF_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        numberOfMessagesList: INITIAL_STATE.numberOfMessagesList,
      };

    // Attendant Assingment Event
    case AttendanceTypes.SET_ATTENDANT_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        attendantAssignmentEvent: action.payload.data,
        messageData:
          state.messageData.Room === action.payload.data.room
            ? {
                ...state.messageData,
                attendantOwnerID: action.payload.data.attendantId,
              }
            : state.messageData,
        openedUsers: state.openedUsers.map((user) =>
          user.Room === action.payload.data.room
            ? {
                ...user,
                attendantOwnerID: action.payload.data.attendantId,
              }
            : user,
        ),
        closedUsers: state.closedUsers.map((user) =>
          user.Room === action.payload.data.room
            ? {
                ...user,
                attendantOwnerID: action.payload.data.attendantId,
              }
            : user,
        ),
        chatbotUsers: state.chatbotUsers.map((user) =>
          user.Room === action.payload.data.room
            ? {
                ...user,
                attendantOwnerID: action.payload.data.attendantId,
              }
            : user,
        ),
      };

    default:
      return state;
  }
};

export default reducer;
export { INITIAL_STATE };
